<template>
  <!-- play -->
  <svg v-if="pause" id="구성_요소_2_1" data-name="구성 요소 2 – 1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="60" height="61.395" viewBox="0 0 60 61.395">
    <defs>
      <filter id="다각형_12" x="4" y="4" width="51.487" height="57.395" filterUnits="userSpaceOnUse">
        <feOffset dy="3" input="SourceAlpha"/>
        <feGaussianBlur stdDeviation="3" result="blur"/>
        <feFlood flood-opacity="0.161"/>
        <feComposite operator="in" in2="blur"/>
        <feComposite in="SourceGraphic"/>
      </filter>
    </defs>
    <rect id="사각형_1" data-name="사각형 1" width="60" height="60" fill="none" opacity="0.5"/>
    <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#다각형_12)">
      <path id="다각형_12-2" data-name="다각형 12" d="M17.584,1.193a2.469,2.469,0,0,1,4.228,0L39.04,29.743a2.469,2.469,0,0,1-2.114,3.744H2.469A2.469,2.469,0,0,1,.355,29.743Z" transform="translate(46.49 10) rotate(90)" fill="#fff"/>
    </g>
  </svg>
  <!-- pause -->
  <svg v-else id="구성_요소_1_1" data-name="구성 요소 1 – 1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="60" height="62" viewBox="0 0 60 62">
    <defs>
      <filter id="사각형_3" x="4" y="4" width="30" height="58" filterUnits="userSpaceOnUse">
        <feOffset dy="3" input="SourceAlpha"/>
        <feGaussianBlur stdDeviation="3" result="blur"/>
        <feFlood flood-opacity="0.161"/>
        <feComposite operator="in" in2="blur"/>
        <feComposite in="SourceGraphic"/>
      </filter>
      <filter id="사각형_4" x="26" y="4" width="30" height="58" filterUnits="userSpaceOnUse">
        <feOffset dy="3" input="SourceAlpha"/>
        <feGaussianBlur stdDeviation="3" result="blur-2"/>
        <feFlood flood-opacity="0.161"/>
        <feComposite operator="in" in2="blur-2"/>
        <feComposite in="SourceGraphic"/>
      </filter>
    </defs>
    <rect id="사각형_2" data-name="사각형 2" width="60" height="60" fill="none" opacity="0.5"/>
    <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#사각형_3)">
      <rect id="사각형_3-2" data-name="사각형 3" width="12" height="40" rx="2" transform="translate(13 10)" fill="#fff"/>
    </g>
    <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#사각형_4)">
      <rect id="사각형_4-2" data-name="사각형 4" width="12" height="40" rx="2" transform="translate(35 10)" fill="#fff"/>
    </g>
  </svg>
</template>
<script>
export default {
    props:{
        pause:Boolean
    },
}
</script>

